import React from 'react';
import { outcomes } from '../data/outcomes';
import { OFFER_ANCHOR } from './constants';
export function ChangeSection() {
  return <section className="bg-white px-3 py-3 sm:px-4 sm:py-4" data-id="element-23" data-mp="zn94f6f1bqu6">
      <div className="mx-auto max-w-4xl" data-id="element-24" data-mp="lwvx969ywg5w">
        <h2 className="mb-1.5 text-center font-display text-xl font-extrabold uppercase leading-tight tracking-tight sm:text-4xl" data-id="element-25" data-mp="lw3zppwt88cz">
          What Will Change
        </h2>
        <div className="grid gap-1.5 sm:grid-cols-2 sm:gap-2" data-id="element-26" data-mp="bx500wu0vn24">
          {outcomes.map(outcome => <a key={outcome.title} href={OFFER_ANCHOR} className="rounded-lg border border-eq-line bg-eq-light p-2.5 shadow-sm transition-colors duration-150 ease-out hover:border-eq-gold sm:p-3" data-id="element-27" data-mp="gycc383778el">
              <h3 className="font-display text-[13px] font-extrabold uppercase leading-tight text-eq-navy sm:text-base" data-id="element-28" data-mp="1xbj77nmnaimc">
                {outcome.title}
              </h3>
              <p className="mt-0.5 text-[12px] font-medium leading-snug text-eq-muted sm:text-sm" data-id="element-29" data-mp="229ugnx912r41">
                {outcome.description}
              </p>
            </a>)}
        </div>
      </div>
    </section>;
}